window.app = window.app || {};

window.app.backInStock = {
  el: {
    form: document.querySelector('.klaviyo-bis'),
    email: document.querySelector('.klaviyo-bis input[name="email"]'),
    product: document.querySelector('.klaviyo-bis input[name="product"]'),
    variant: document.querySelector('.klaviyo-bis input[name="variant"]'),
    error: document.querySelector('.klaviyo-bis__error'),
    step: {
      signup: document.querySelector('.klaviyo-bis__step--signup'),
      success: document.querySelector('.klaviyo-bis__step--success'),
    },
  },
  endpoint: 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=JMgD4Y',

  init: function () {
    const _this = this;
    if (!_this.el.form) return;

    _this.footerObserver();

    _this.el.form.addEventListener('submit', (e) => {
      e.preventDefault();

      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": _this.el.email.value,
                }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": `$shopify:::$default:::${_this.el.variant.value}`
              }
            }
          }
        }
      };

      fetch(_this.endpoint, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision": '2024-10-15',
        },
        body: JSON.stringify(payload),
      })
        .then(response => {
          if (response.status === 202) {
            _this.el.step.signup.classList.add('hidden');
            _this.el.step.success.classList.remove('hidden');
          } else {
            _this.el.error.classList.remove('hidden');
          }
        })
        .catch(error => {
          _this.el.error.classList.remove('hidden');
        });
    });
  },
  footerObserver: function () {
    const _this = this;
    const siteFooter = document.querySelector('.mt-footer-v2');

    const observer = new IntersectionObserver((entries) => {
      entries.map((entry) => {
        if (entry.isIntersecting) {
          _this.el.form.classList.add('slide-down');
        } else {
          _this.el.form.classList.remove('slide-down');
        }
      });
    });
    observer.observe(siteFooter);
  },
};

document.addEventListener('DOMContentLoaded', () => {
  window.app.backInStock.init();
});